import React from 'react';
import {DialogModal, DialogWrapper} from './DialogStyles';

interface ModalDialogProps {
  children: React.ReactNode;
  open: any;
  onClose: any;
  flowSheetScreen?: any;
  isVitalDataGrid?: any;
}

const ModalDialog = (props: ModalDialogProps): React.ReactElement => {
  const {
    children,
    onClose,
    open,
    flowSheetScreen = false,
    isVitalDataGrid = false
  } = props;

  return (
    <DialogModal
      open={open}
      onClose={onClose}
      fullScreen={flowSheetScreen}
      isFlowSheetScreen={flowSheetScreen}
      isVitalDataGrid={isVitalDataGrid}>
      <DialogWrapper>{children}</DialogWrapper>
    </DialogModal>
  );
};
export default ModalDialog;
